// extracted by mini-css-extract-plugin
export var cardWrapper = "_80-0";